import { ComponentForm } from "./ComponentForm";


export class TipiButtonForm {
  static types: ComponentForm [] = [];

  static initialize() {
    if (this.types.length === 0) {
      this.addTipo('button_ok', 'OK', 0);
      this.addTipo('button_annulla', 'Annulla', 1);
      this.addTipo('button_salva', 'Salva', 2);
    }
  }

  static addTipo(cm_module_name: string, cm_description: string, type: number): void {
    const campo = new ComponentForm();
    campo.cm_module_name = cm_module_name;
    campo.cm_description = cm_description;
    campo.type = type;
    this.types.push(campo);
  }

  static getTypes(): ComponentForm[] {
    return this.types;
  }
}
